import { Github, MessageCircle, Linkedin } from "lucide-react";

export interface SocialLink {
  url: string;
  label: string;
  icon: string;
  available: boolean;
}

export const socialLinks: Record<string, SocialLink> = {
  github: {
    url: "https://github.com/TokDar2410621",
    label: "GitHub",
    icon: "Github",
    available: true
  },
  whatsapp: { 
   url: "https://wa.me/12632886050?text=Bonjour%20Tokam%2C%20j%27ai%20vu%20votre%20portfolio%20et%20j%27aimerais%20vous%20contacter.",

    label: "WhatsApp",
    icon: "MessageCircle",
    available: true
  },
  linkedin: {
    url: "https://www.linkedin.com/in/darius-tokam-1677b72a7/",
    label: "LinkedIn",
    icon: "Linkedin",
    available: true
  }
};
/**
 * Les seules icones dont les liens sociaux ont besoin.
 *
 * Avant, Contact et Footer importaient le baril `icons` de lucide-react pour
 * resoudre `social.icon` a l'execution. Un baril, ca ne se secoue pas : les
 * ~1500 icones de la librairie partaient dans le bundle pour en afficher
 * trois. Ce tableau explicite rend l'arbre secouable.
 */
export const ICONES_SOCIALES = { Github, MessageCircle, Linkedin } as const;
